/**
 * 使用请求
 * @return {object} { get: function, post: function, bind: function }
 */
export function useRequest() {
    return window?.FEGORender?.common?.request || window?.FEGOEditor?.common?.request;
}
